import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format price from cents to display
export function formatPrice(cents, currency = 'EUR') {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: currency,
  }).format(cents / 100);
}

// Format date
export function formatDate(dateString, locale = 'fr-FR') {
  return new Date(dateString).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

// Format date short
export function formatDateShort(dateString, locale = 'fr-FR') {
  return new Date(dateString).toLocaleDateString(locale, {
    month: 'short',
    day: 'numeric',
  });
}

// Format datetime
export function formatDateTime(dateString, locale = 'fr-FR') {
  return new Date(dateString).toLocaleString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

// Order status display
export const ORDER_STATUS = {
  PENDING_PAYMENT: { label: 'En attente', color: 'bg-yellow-500/20 text-yellow-500' },
  PAID: { label: 'Payée', color: 'bg-emerald-500/20 text-emerald-500' },
  PROCESSING: { label: 'En préparation', color: 'bg-blue-500/20 text-blue-500' },
  SHIPPED: { label: 'Expédiée', color: 'bg-purple-500/20 text-purple-500' },
  DELIVERED: { label: 'Livrée', color: 'bg-green-500/20 text-green-500' },
  CANCELLED: { label: 'Annulée', color: 'bg-gray-500/20 text-gray-500' },
  REFUNDED: { label: 'Remboursée', color: 'bg-red-500/20 text-red-500' },
  REFUND_PENDING: { label: 'Remboursement en cours', color: 'bg-orange-500/20 text-orange-500' },
};

// Lead source display
export const LEAD_SOURCE = {
  QUIZ: { label: 'Quiz', icon: '🎯' },
  NEWSLETTER: { label: 'Newsletter', icon: '📧' },
  POPUP: { label: 'Pop-up', icon: '💬' },
  CHECKOUT_STARTED: { label: 'Checkout', icon: '🛒' },
  ABANDONED_CART: { label: 'Panier abandonné', icon: '🛍️' },
  PROMO: { label: 'Promo', icon: '🎁' },
};

// Truncate text
export function truncate(str, length = 50) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}

// Generate random ID
export function generateId() {
  return Math.random().toString(36).substr(2, 9);
}

// Debounce function
export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Calculate savings percentage
export function calculateSavingsPercent(original, bundle) {
  if (!original || !bundle) return 0;
  return Math.round(((original - bundle) / original) * 100);
}
